<template>
  <div class="box9" id="box9">
    <pageTitle
      title="学完即可掌握LLM大语言模型<br/>核心技能"
      titleColor="#02154B"
      titColor="#02154B"
      ref="pageTitle"
      text="可运用Prompt-Tuning、 LangChain等方法，从0-1构建大模型"
    />
    <div class="subjectContent" :style="{ height: expand ? 'auto' : '13.5rem' }">
      <div class="item" v-for="(item, index) in list1" :key="index">
        <h1>{{ item.h1 }}</h1>
        <i></i>
        <p v-html=" item.p"></p>
      </div>
    </div>
    <div class="pic-05" :class="expand?'expand':''">
      <img v-if="!expand" class="more" @click="show()" src="../../../assets/coursePage/ai2/box9/more.png"/>
    </div>
  </div>
</template>

<script>
import pageTitle from "../common/pageTitle.vue";
export default {
  components: {
    pageTitle,
  },
  methods: {
    show(){
        this.expand=true
      },
  },
  data() {
    return {
      expand:false,
      list1: [
        {
          h1: "夯实理论基础",
          p: "掌握大语言模型的基本思想，了解语言模型的主要方法及常见语言模型的评价指标。",
        },
        {
          h1: "经典Prompt任务实战经验积累",
          p: "玩转PET、P-Tuning等不同Prompt方式，实现多文本分类任务的应用实现，对比分析不同微调方式的优缺点及使用场景。",
        },
        {
          h1: "大模型开发框架应用",
          p: "掌握LangChain核心组件构成及原理，基于ChatGLM构建本地知识库的问答系统，为企业提供更有价值的解决方案。",
        },
        {
          h1: "开源大模型原理剖析",
          // p: "了解大模型的主要类别架构：Encoder_only、Decoder_only、Encoder_Decoder，掌握LLaMA、ChatGLM、BLOOM等主流开源大模型的架构及原理等。",
          p: "<b class='b'>了解大模型的主要类别架构：Encoder_only、</b><b  class='b'>Decoder_only、Encoder_Decoder，掌握</b><b  class='b'>LLaMA、ChatGLM、BLOOM等主流开源大模</b><b  class='b'>型的架构及原理等。</b>",
        },
        {
          h1: "大模型开发应用实现",
          p: "基于zero-shot方式实现ChatGLM模型进行多任务应用，用Prompt-Tuning方法实现ChatGLM大模型完成信息抽取，包括：文本分类、文本匹配、信息抽取等企业应用实践。",
        },
        {
          h1: "全方位大模型微调手段",
          p: "掌握面向大模型的Prompt-Tuning方法，包括In-Context learning、Instruction-Tuning、Chain-of-Thought、PEFT（Adapter-Tuning、LoRA、Prefix_Tuning等）等方式。",
        },
      ],
    };
  },
};
</script>
<style lang="scss">
 .b{
          display: block;
          white-space: nowrap;
          font-style: normal;
          font-family: PingFangSC, PingFang SC;
        font-weight: 400;
        font-size: 28px;
        color: #051648;
        line-height: 48px;
        text-align: left;
        font-style: normal;
        }
</style>
<style lang="scss" scoped>
.box9 {
  padding: 80px 0 0;
  width: 100%;
  background: linear-gradient(180deg, #f7fbff 0%, #d9e9ff 100%);
  .pic-05{
   
    position: relative;
   
    .more{
      position: absolute;
      bottom: 0;
      right: 0;
      width: 100%;
    }
  }
  .expand{
    height: auto;
  }
  .subjectContent {
    overflow: hidden;
    margin-top: 48px;
    .item {
      background-image: url("../../../assets/coursePage/ai2/box9/bg01.png");
      background-repeat: no-repeat;
      background-size: 100% 100%;
       height: 360px;
      padding: 48px 90px 0;
      margin-top: -60px;
      box-sizing: border-box;

      h1 {
        font-family: PingFangSC, PingFang SC;
        font-weight: 600;
        font-size: 32px;
        color: #051648;
        line-height: 52px;
        text-align: left;
        font-style: normal;
      }
      i {
        width: 40px;
        height: 4px;
        background: linear-gradient(270deg, #b3e0ff 0%, #63a3ff 100%);
        display: block;
        margin: 16px 0;
      }
      p {
        font-family: PingFangSC, PingFang SC;
        font-weight: 400;
        font-size: 28px;
        color: #051648;
        line-height: 48px;
        text-align: left;
        font-style: normal;
        
      }
    
    }
    .item:nth-child(1){
      margin-top: 0;
    }
    .item:nth-child(2){
      min-height: 420px;
      margin-top: -80px;
    }
    .item:nth-child(3){
      min-height: 420px;
      margin-top: -100px;
    }
    .item:nth-child(4){
      min-height: 480px;
      margin-top: -100px;
    }
    .item:nth-child(5){
      min-height: 500px;
      padding-top: 58px;
      margin-top: -110px;
    }
    .item:nth-child(6){
      min-height: 500px;
      padding-top: 58px;
      margin-top: -120px;
    }
  }
}
</style>
